import { type JSX, useContext } from "react";

import {
  SubstructureComponentsContext,
  SubstructureVariant,
  useSubstructureLayout,
} from "@plansoft-configuration-renderer/components";

import { CustomSubstructureEmbedded } from "@/renderer/controls/CustomSubstructureEmbeded/CustomSubstructureEmbedded";

export function CustomSubstructure(): JSX.Element {
  const { variant } = useSubstructureLayout();

  const Components = useContext(SubstructureComponentsContext);

  if (variant === SubstructureVariant.Stub) {
    return <Components.SubstructureStub />;
  }

  if (variant === SubstructureVariant.Content) {
    return <Components.SubstructureEmbeddedContent />;
  }

  if (variant === SubstructureVariant.Embedded) {
    return <CustomSubstructureEmbedded />;
  }

  return <CustomSubstructureEmbedded />;
}

CustomSubstructure.displayName = "CustomSubstructure";
